// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Vtyj","productName":"Table_productName__k1dQQ"};